module.exports = __webpack_public_path__ + "static/media/affiliate-network-mapping.da10841b.jpg";